<template>
  <div
    class="Texture__Container"
    ref="Container"
    @mousemove="TouchMove(0)"
    @mouseup="EndTouch()"
  >
    <div
      class="Texture__PtContainer"
      ref="Pt0"
    >
      <div
        class="Texture__PtCircle"
        v-show="highlightedPt === 0"
        ref="Pt0Circle"
      >
        <div
          class="Texture__PtForce"
          @touchstart="TouchStart(0)"
          @touchmove="TouchMove()"
          @mousedown="TouchStart(0)"
        />
        <!--
        <div class="Texture__PtResize">
          <div class="Texture__PtResizeIcon" />
        </div>
        -->
      </div>
      <div
        class="Texture__Pt"
        ref="Pt0Point"
        @click="SelectPoint(0)"
        @mousedown="DragPoint(0)"
        @touchstart="DragPoint(0)"
      >
        <p
          class="Texture__PtText"
          ref="Pt0Text"
        >
          A
        </p>
      </div>
    </div>
    <div
      class="Texture__PtContainer"
      ref="Pt1"
    >
      <div
        class="Texture__PtCircle"
        v-show="highlightedPt === 1"
        ref="Pt1Circle"
      >
        <div
          class="Texture__PtForce"
          @touchstart="TouchStart(1)"
          @touchmove="TouchMove()"
          @mousedown="TouchStart(1)"
        />
        <!--
        <div class="Texture__PtResize">
          <div class="Texture__PtResizeIcon" />
        </div>
        -->
      </div>
      <div
        class="Texture__Pt"
        ref="Pt1Point"
        @click="SelectPoint(1)"
        @mousedown="DragPoint(1)"
        @touchstart="DragPoint(1)"
      >
        <p
          class="Texture__PtText"
          ref="Pt1Text"
        >
          B
        </p>
      </div>
    </div>
    <div
      class="Texture__PtContainer"
      ref="Pt2"
    >
      <div
        class="Texture__PtCircle"
        v-show="highlightedPt === 2"
        ref="Pt2Circle"
      >
        <div
          class="Texture__PtForce"
          @touchstart="TouchStart(2)"
          @touchmove="TouchMove()"
          @mousedown="TouchStart(2)"
        />
        <!--
        <div class="Texture__PtResize">
          <div class="Texture__PtResizeIcon" />
        </div>
        -->
      </div>
      <div
        class="Texture__Pt"
        ref="Pt2Point"
        @click="SelectPoint(2)"
        @mousedown="DragPoint(2)"
        @touchstart="DragPoint(2)"
      >
        <p
          class="Texture__PtText"
          ref="Pt2Text"
        >
          C
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus.js'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      startX: 0,
      startY: 0,
      originX: 0,
      originY: 0,
      forceOriginA: 0,
      forceOriginB: 0,
      forceOriginC: 0,
      draggedPt: -1
    }
  },
  mounted () {
    EventBus.$on('PtScreenPositionUpdated', (data) => {
      this.PlacePins(data)
    })
    this.SetRadius()
  },
  computed: {
    ...mapGetters(['highlightedPt', 'force01', 'force02', 'force03'])
  },
  watch: {
    force01 () {
      this.SetRadius()
    },
    force02 () {
      this.SetRadius()
    },
    force03 () {
      this.SetRadius()
    }
  },
  beforeDestroy () {
    this.$store.dispatch('SetHighlightedPt', -1)
    EventBus.$off('PtScreenPositionUpdated')
  },
  methods: {
    PlacePins (data) {
      const sizeBig = 30
      const sizeSmall = 16
      const textSizeBig = 1
      const textSizeSmall = 0.7

      const sizeA = data.A.visible ? sizeBig : sizeSmall
      const sizeB = data.B.visible ? sizeBig : sizeSmall
      const sizeC = data.C.visible ? sizeBig : sizeSmall
      const textSizeA = data.A.visible ? textSizeBig : textSizeSmall
      const textSizeB = data.B.visible ? textSizeBig : textSizeSmall
      const textSizeC = data.C.visible ? textSizeBig : textSizeSmall

      this.$refs.Pt0Point.style.width = sizeA + 'px'
      this.$refs.Pt0Point.style.height = sizeA + 'px'
      this.$refs.Pt0Point.style.left = -sizeA / 2 + 'px'
      this.$refs.Pt0Point.style.top = -sizeA / 2 + 'px'
      this.$refs.Pt0.style.left = data.A.x + 'px'
      this.$refs.Pt0.style.top = data.A.y + 'px'
      this.$refs.Pt0.style.opacity = data.A.visible ? 1 : 0.3
      this.$refs.Pt0Text.style.fontSize = textSizeA + 'em'

      this.$refs.Pt1Point.style.width = sizeB + 'px'
      this.$refs.Pt1Point.style.height = sizeB + 'px'
      this.$refs.Pt1Point.style.left = -sizeB / 2 + 'px'
      this.$refs.Pt1Point.style.top = -sizeB / 2 + 'px'
      this.$refs.Pt1.style.left = data.B.x + 'px'
      this.$refs.Pt1.style.top = data.B.y + 'px'
      this.$refs.Pt1.style.opacity = data.B.visible ? 1 : 0.3
      this.$refs.Pt1Text.style.fontSize = textSizeB + 'em'

      this.$refs.Pt2Point.style.width = sizeC + 'px'
      this.$refs.Pt2Point.style.height = sizeC + 'px'
      this.$refs.Pt2Point.style.left = -sizeC / 2 + 'px'
      this.$refs.Pt2Point.style.top = -sizeC / 2 + 'px'
      this.$refs.Pt2.style.left = data.C.x + 'px'
      this.$refs.Pt2.style.top = data.C.y + 'px'
      this.$refs.Pt2.style.opacity = data.C.visible ? 1 : 0.3
      this.$refs.Pt2Text.style.fontSize = textSizeC + 'em'
    },
    SelectPoint (index) {
      if (this.$refs['Pt' + index].style.opacity < 0.8) {
        this.$store.dispatch('SetHighlightedPt', index)
      }
      EventBus.$emit('PointActivated')
    },
    SetRadius () {
      const minSize = 80
      const maxSize = 200
      this.$refs.Pt0Circle.style.width = minSize + (maxSize * this.force01) + 'px'
      this.$refs.Pt1Circle.style.width = minSize + (maxSize * this.force02) + 'px'
      this.$refs.Pt2Circle.style.width = minSize + (maxSize * this.force03) + 'px'
      this.$refs.Pt0Circle.style.height = minSize + (maxSize * this.force01) + 'px'
      this.$refs.Pt1Circle.style.height = minSize + (maxSize * this.force02) + 'px'
      this.$refs.Pt2Circle.style.height = minSize + (maxSize * this.force03) + 'px'
      this.$refs.Pt0Circle.style.top = -minSize / 2 - (maxSize * this.force01) / 2 + 'px'
      this.$refs.Pt1Circle.style.top = -minSize / 2 - (maxSize * this.force02) / 2 + 'px'
      this.$refs.Pt2Circle.style.top = -minSize / 2 - (maxSize * this.force03) / 2 + 'px'
      this.$refs.Pt0Circle.style.left = -minSize / 2 - (maxSize * this.force01) / 2 + 'px'
      this.$refs.Pt1Circle.style.left = -minSize / 2 - (maxSize * this.force02) / 2 + 'px'
      this.$refs.Pt2Circle.style.left = -minSize / 2 - (maxSize * this.force03) / 2 + 'px'
    },
    DragPoint (index) {
      if (this.$refs['Pt' + index].style.opacity > 0.8) {
        EventBus.$emit('StartPtDrag', index)
      }
      this.SelectPoint(index)
    },
    TouchStart (ptIndex) {
      if (window.event.clientX || window.event.touches.length > 0) {
        this.startX = window.event.clientX || window.event.touches[0].clientX
        this.startY = window.event.clientY || window.event.touches[0].clientY
        this.originX = this.$refs['Pt' + ptIndex].getBoundingClientRect().left
        this.originY = this.$refs['Pt' + ptIndex].getBoundingClientRect().top
        this.forceOriginA = this.force01
        this.forceOriginB = this.force02
        this.forceOriginC = this.force03
        this.draggedPt = ptIndex
        if (window.event.clientX) {
          this.$refs.Container.style.pointerEvents = 'auto'
        }
      }
    },
    TouchMove () {
      const clientX = window.event.clientX || window.event.touches[0].clientX
      const clientY = window.event.clientY || window.event.touches[0].clientY
      const vecStart = [this.originX - this.startX, this.originY - this.startY]
      const vecTouch = [this.startX - clientX, this.startY - clientY]
      const dot = this.DotProduct(vecStart, vecTouch)
      const reductionFactor = 4000
      switch (this.draggedPt) {
        case 0:
          this.$store.dispatch('SetForces', [Math.min(Math.max(parseFloat(this.forceOriginA) + (dot / reductionFactor), 0), 1), this.force02, this.force03])
          break
        case 1:
          this.$store.dispatch('SetForces', [this.force01, Math.min(Math.max(parseFloat(this.forceOriginB) + (dot / reductionFactor), 0), 1), this.force03])
          break
        case 2:
          this.$store.dispatch('SetForces', [this.force01, this.force02, Math.min(Math.max(parseFloat(this.forceOriginC) + (dot / reductionFactor), 0), 1)])
          break
      }
    },
    DotProduct (vector1, vector2) {
      let result = 0
      for (let i = 0; i < 2; i++) {
        result += vector1[i] * vector2[i]
      }
      return result
    },
    EndTouch () {
      this.$refs.Container.style.pointerEvents = 'none'
      this.draggedPt = -1
    }
  }
}
</script>

<style scoped>
.Texture__Container{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.Texture__Pt{
  width: 25px;
  height: 25px;
  background: black;
  border-radius: 20px;
  position: absolute;
  display: flex;
  pointer-events: auto;
}

.Texture__PtText {
  color: white;
  margin: auto;
}

.Texture__PtContainer {
  position: absolute;
  width: 1px;
  height: 1px;
}

.Texture__PtCircle {
  position: absolute;
  width: 80px;
  height: 80px;
  border-radius: 100%;
  top: -40px;
  left: -40px;
  display: flex;
  justify-content: center;
}

.Texture__PtForce {
  position: absolute;
  background: green;
  border-radius: 100%;
  margin: auto;
  width: 90%;
  height: 90%;
  align-self: center;
  background: rgba(255, 179, 0, 0.12);
  border: solid rgba(255, 179, 0, 1) 1px;
  pointer-events: auto;
}

.Texture__PtResize {
  width: 26px;
  height: 26px;
  background: white;
  border-radius: 100%;
  margin-top : -13px;
  display: flex;
  z-index: 10;
}

.Texture__PtResizeIcon {
    margin: auto;
    width: 15px;
    height: 15px;
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
    background: black;
    pointer-events: auto;
    mask-image: url('../../assets/icons/arrow-up-down.svg');
}
</style>
